import { PUBLIC_IMAGES_BASE_URI } from "../../../config/api.config";
/* eslint-disable no-unused-vars, no-empty */
import { lazy, Suspense, useContext, useEffect, useState } from "react";
const _OFFER_END = new Date("2026-06-28T23:59:59+05:30");
const NAV_FREE_TAG = Date.now() <= _OFFER_END.getTime();
import "./Navbar.css";
import { Box, Drawer, Modal, Select } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { trackNavClick } from "../../../lib/funnels";
import { useDispatch, useSelector } from "react-redux";
import {
  createReferral,
  getCredits,
  getProfile,
  updateUserStatus,
} from "../../../redux/features/customer/customerActions";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { logout } from "../../../common/utils/logout";
import { isLoggedIn } from "../../../common/utils/isLoggedIn";
// Heavy modal/drawer components — lazy so their chunks (Login pulls in
// react-phone-input-2 + react-google-recaptcha) load only when the user opens
// the auth / wallet / credits / notification UI, not on every page's navbar.
const Notification = lazy(
  () => import("../../../pages/Dashboard/components/Notification/Notification"),
);
import jaaga from "./Group.webp";
import {
  OutOFCreditsPopUpHandler,
  clearCustomer,
  clearCustomerDeleteKycDoc,
  clearCustomerKycDoc,
  clearCustomerShareKycDoc,
  clearCustomerUpdateKycDoc,
  clearCustomeraddAddressErrorMsg,
  clearCustomerdeleteAddressErrorMsg,
  clearCustomerupdateAddressErrorMsg,
  clearCutomerErrorMessage,
  clearUserProfilePicErrorMessage,
  clearnomineeProfileUpdateError,
  clearnomineeProfilepicError,
} from "../../../redux/features/customer/customerSlice";
import {
  clearLogin,
  loginPopupHandler,
} from "../../../redux/features/auth/loginSlice";
import { clearSignup } from "../../../redux/features/auth/signupSlice";
import { TranslationContext } from "../../context/TranslationContext";
const Login = lazy(() => import("../../../pages/Authentication/Login"));
import { logoutUser } from "../../../redux/features/auth/loginActions";
import { Coin, Dashboard } from "../../../assets";
const OutOfCredits = lazy(() => import("../../../pages/Wallet/OutOfCredits"));
const Wallet = lazy(() => import("../../../pages/Wallet/Wallet"));
import { setPropertiesMenu } from "../../../redux/features/navbar/navbarSlice";
import {
  clearDeleteDocErrorMsg,
  clearErrorMessage,
  clearRiskErrorMsg,
  clearUniversalSearchSuggestion,
  clearUploadDocErrorMsg,
  clearVerifyDocErrorMsg,
  clearshareDocErrorMsg,
} from "../../../redux/features/property/propertySlice";
import toast from "react-hot-toast";
import {
  getSingleorderdata,
  getunreadMsgsOrders,
  getunseenPaymentsInTransactions,
} from "../../../redux/features/dashBoard/dashBoardActions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  BellDotIcon,
  BellIcon,
  ChevronDown,
  ChevronUp,
  CoinsIcon,
  LayoutDashboard,
  Share,
  Share2,
  Share2Icon,
  ShareIcon,
  Plus,
  Zap,
  Gift,
  MessageSquare,
  MessageCircle,
  RefreshCw,
  UserX,
  LogOut,
  ChevronRight,
  X as CloseX,
  Pencil,
  CreditCard,
  FileText,
  Briefcase,
  Sparkles,
  Map as MapIcon,
  Building2,
  Users2,
  Headset,
} from "lucide-react";
import { useRef } from "react";
import SearchableDropdown from "../SearchableDropdown/SearchableDropdown";
import BottomNav from "./BottomNav";
import PropertiesNavMenu from "./PropertiesNavMenu";
import MobileKeyboardManager from "../MobileKeyboardManager/MobileKeyboardManager";
import RefferModal from "../ShareModal/RefferModal";
import * as assets from "../../../assets/index";
import { Button } from "../../../components/ui/button";
import { useCreditsConfig } from "../../../hooks/useCreditsConfig";

const Navbar = () => {
  const { joiningCredits, referralCredits } = useCreditsConfig();
  const { pathname } = useLocation();

  // Which top-nav section the user is currently in. Detail pages for
  // Documents / Services route to top-level slugs (e.g. /telangana,
  // /sale-deed) that don't sit under the nav path, so plain NavLink
  // matching loses the highlight. We resolve the section by URL prefix and
  // keep the last section "sticky" on those slug pages so the active item
  // stays lit while the user is inside that area.
  const NAV_MATCHERS = [
    // Community must be tested BEFORE listings (the Properties dropdown, which
    // owns the rest of /properties): find() returns the first match.
    { id: "community", test: (p) => p.startsWith("/properties/community") },
    { id: "listings", test: (p) => p.startsWith("/properties") },
    {
      id: "my_locker",
      test: (p) =>
        p.startsWith("/maps") ||
        p.endsWith("/survey-number-map") ||
        p.startsWith("/draw-land-map"),
    },
    { id: "orders", test: (p) => p.startsWith("/customer") },
    { id: "property_docs", test: (p) => p.startsWith("/states") },
    { id: "property_services", test: (p) => p.startsWith("/services") },
    { id: "intelligence", test: (p) => p.startsWith("/intelligence") },
    { id: "contact_us", test: (p) => p.startsWith("/contactus") },
  ];
  const NO_SECTION = [
    "/about",
    "/calculators",
    "/app",
    "/get-app",
    "/wallet",
    "/terms",
    "/privacy-policy",
    "/refund-cancellation-policy",
    "/shipping-delivery-policy",
  ];
  const [activeNavId, setActiveNavId] = useState(
    () => sessionStorage.getItem("activeNav") || null,
  );
  useEffect(() => {
    const matched = NAV_MATCHERS.find((m) => m.test(pathname))?.id;
    if (matched) {
      setActiveNavId(matched);
      sessionStorage.setItem("activeNav", matched);
    } else if (pathname === "/" || pathname === "" || NO_SECTION.some((p) => pathname.startsWith(p))) {
      // Home and pages outside every section clear the active section, so the
      // last one visited doesn't stay lit (e.g. "Listings" on /about).
      setActiveNavId(null);
      sessionStorage.removeItem("activeNav");
    } else {
      // Top-level slug detail page (e.g. /telangana/sale-deed). Sync the
      // highlight from sessionStorage so a document opened from the homepage
      // still lights up "Documents".
      const stored = sessionStorage.getItem("activeNav");
      if (stored) setActiveNavId(stored);
    }
  }, [pathname]);

  const [AuthModals, setAuthModals] = useState({
    Login: false,
  });
  const { contentData: CD, lang, setLang } = useContext(TranslationContext);
  const propertiesMenu = useSelector((state) => state.navbar.propertiesMenu);
  const userOrdersData = useSelector((state) => {
    state.dashBoard.apiData;
  });
  const transactionsRequestData = useSelector((state) => {
    return state.dashBoard.transactionApiData;
  });
  const referralCode = useSelector((state) => state.customer.referralCode);
  const newPayments = useSelector((state) => {
    state.dashBoard.unseenPayment;
  });

  const paymentOrderId = useSelector((state) => {
    return state.dashBoard.paymentOrderId;
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("loginMode");
  const [selectedNav, setSelectedNav] = useState("/");
  const [openCreditsPopUp, setOpenCreditsPopUp] = useState(false);
  const [options, setOptions] = useState(false);

  const [unreadMsgs, setUnreadMsgs] = useState([]);
  const [unPaidtransactions, setUnpaidTransactions] = useState([]);
  const [openreferralModal, setOpenReferralModal] = useState(false);
  const [referralCodeUrl, setReferralCodeUrl] = useState("");
  const { isLogout } = useSelector((state) => state.login);

  const OutOFCreditsPopUp = useSelector((state) => {
    return state.customer.OutOFCreditsPopUp;
  });

  const credits = useSelector((state) => {
    return state.customer.credits;
  });

  const loginPopUp = useSelector((state) => {
    return state.login.loginPopUp;
  });

  const [WalletAnchorEl, setAnchorEl] = useState(null);
  // Notifications open as a right-side drawer (same as the wallet and profile
  // panels), so it's a plain open flag rather than a popover anchor.
  const [openNotification, setOpenNotification] = useState(false);

  const toggleWallet = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleWalletClose = () => {
    setAnchorEl(null);
  };

  const toggleNotification = () => {
    setOpenNotification(true);
  };

  const handleNotificationClose = () => {
    setOpenNotification(false);
  };

  const openWallet = Boolean(WalletAnchorEl);
  const walletId = openWallet ? "simple-popover" : undefined;

  const unreadMsg = useSelector((state) => {
    return state?.dashBoard?.msgNotification;
  });

  const unpaidPayment = useSelector((state) => {
    return state?.dashBoard.paymentNotification;
  });

  useEffect(() => {
    if (Object.keys(unreadMsg)?.length > 0) {
      navigate("/dashboard");
    }

    if (Object.keys(unpaidPayment)?.length > 0) {
      navigate("/dashboard");
    }
  }, [unreadMsg, unpaidPayment]);

  const token = localStorage.getItem("token");
  // Reactive login signal (set in the OTP-verify thunk right after the token
  // lands in localStorage) so the auth-scoped notification fetches below re-run
  // the moment the user logs in, without a page reload.
  const accessToken = useSelector((state) => state.login?.accessToken);

  useEffect(() => {
    // These hit user-scoped order/transaction endpoints (`order/overview`,
    // `transaction/overview`, `/order/:id`) with x-auth-token → 401 when logged
    // out, and the Navbar mounts on EVERY page. Only run them with a session so
    // anonymous visitors don't spam the api with rejected calls.
    if (!isLoggedIn()) return;

    const data = transactionsRequestData;

    const pageNumber = 1;

    const orderId = paymentOrderId;

    // Only fetch when an order is actually selected. paymentOrderId defaults to
    // "" on mount, and calling this with an empty id hit GET /api/payment/order/
    // (a 404) on every page load.
    if (orderId) {
      dispatch(getSingleorderdata(orderId)).then((res) => {});
    }

    dispatch(getunreadMsgsOrders({ data, pageNumber })).then((res) => {
      const orders = res?.payload?.response?.data?.data?.items;

      if (res?.payload?.response?.status === 200) {
      }

      const temp = [];

      for (let i = 0; i < orders?.length; i++) {
        if (orders[i]?.unReadMessages > 0) {
          temp.push({ ...orders[i], index: i });
        }
      }

      setUnreadMsgs(temp);
    });

    dispatch(getunseenPaymentsInTransactions({ data, pageNumber })).then(
      (res) => {
        const trasactions = res?.payload?.response?.data?.data?.items;

        const tempData = [];

        for (let i = 0; i < trasactions?.length; i++) {
          if (
            trasactions[i]?.paymentURL &&
            trasactions[i].status !== "SUCCESS"
          ) {
            tempData.push({ ...trasactions[i], index: i });
          }
        }

        if (newPayments?.length > 0) {
          setUnpaidTransactions(newPayments);
        }

        setUnpaidTransactions(tempData);
      },
    );
  }, [accessToken]);

  useEffect(() => {
    const pageNumber = localStorage.getItem("pageIndex");
    if (pageNumber) {
      localStorage.removeItem("pageIndex");
    }
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      if (userType === "customer" && !customerInfo.name) {
        dispatch(getProfile());
      }
    }
    if (sessionStorage.getItem("docDraft")) {
      // docDfrat exists, so print "Hello"
    } else {
      sessionStorage.setItem("docDraft", JSON.stringify([]));
    }
    if (sessionStorage.getItem("ctdocDraft")) {
      // docDfrat exists, so print "Hello"
    } else {
      sessionStorage.setItem("ctdocDraft", JSON.stringify([]));
    }
    if (sessionStorage.getItem("spdocDraft")) {
      // docDfrat exists, so print "Hello"
    } else {
      sessionStorage.setItem("spdocDraft", JSON.stringify([]));
    }
    if (userType !== "servicePartner" && userType !== "admin") {
    }
    JSON.parse(localStorage.getItem("isPublic")) === null &&
      localStorage.setItem("isPublic", true);
  }, []);

  useEffect(() => {
    // Auth-scoped notification poll (`transaction/overview`, x-auth-token → 401
    // when logged out). Don't even register the listeners for anonymous visitors;
    // re-runs on login via the `accessToken` dep so it wires up post-login.
    if (!isLoggedIn()) return;
    const data = transactionsRequestData;

    const updateUserStatusHandler = () => {
      setTimeout(() => {
        // Re-read at fire time (not the stale mount-time closure) so it reflects
        // the current session and always sends a real pageIndex.
        const loginMode = localStorage.getItem("loginMode");
        const token = localStorage.getItem("token");
        const pageNumber = localStorage.getItem("pageIndex") || 1;
        if (token && loginMode === "customer") {
          dispatch(getunseenPaymentsInTransactions({ data, pageNumber })).then(
            (res) => {
              const trasactions = res?.payload?.response?.data?.data?.items;

              const tempData = [];
              for (let i = 0; i < trasactions?.length; i++) {
                if (
                  trasactions[i]?.paymentURL &&
                  trasactions[i].status !== "SUCCESS"
                ) {
                  tempData.push({ ...trasactions[i], index: i });
                }
              }

              if (newPayments?.length > 0) {
                setUnpaidTransactions(newPayments);
              }
              setUnpaidTransactions(tempData);
            },
          );
        }
      }, 1000);
    };

    const handleVisibilityChange = () => {
      updateUserStatusHandler();
    };

    const handleLoad = () => {
      updateUserStatusHandler();
    };

    const handleBeforeUnload = () => {
      updateUserStatusHandler();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("load", handleLoad);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      window.removeEventListener("load", handleLoad);
      window.removeEventListener("beforeunload", handleBeforeUnload);

      window.addEventListener("unload", handleLoad);
    };
  }, [accessToken]);

  useEffect(() => {
    if (newPayments?.length > 0) {
      setUnpaidTransactions(newPayments);
    }
  }, [newPayments]);

  const clearSeenMessage = (orderId) => {
    const temp = unreadMsgs();
  };

  useEffect(() => {
    if (Object.keys(unreadMsg)?.length > 0) {
      const clearedData = [];
      unreadMsgs?.map((msg) => {
        if (msg?.orderId !== unreadMsg?.orderId) {
          clearedData.push(msg);
        }
      });

      setUnreadMsgs(clearedData);
    }
  }, [unreadMsg]);

  const errorMessage = useSelector((state) => {
    return state.property.errorMessage;
  });

  useEffect(() => {
    if (errorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearErrorMessage());
      }, 60000);
    }
  }, [errorMessage]);

  const customerErrorMessage = useSelector((state) => {
    return state.customer.errorMessage;
  });

  useEffect(() => {
    if (customerErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCutomerErrorMessage());
      }, 60000);
    }
  }, [customerErrorMessage]);

  const userProfilePicErrorMessage = useSelector((state) => {
    return state.customer.userProfilePicErrorMessage;
  });

  useEffect(() => {
    if (userProfilePicErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearUserProfilePicErrorMessage());
      }, 60000);
    }
  }, [userProfilePicErrorMessage]);

  const kycErrorMessage = useSelector((state) => {
    return state.customer.kycErrorMessage;
  });

  useEffect(() => {
    if (kycErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerKycDoc());
      }, 60000);
    }
  }, [kycErrorMessage]);

  const updateKycErrorMessage = useSelector((state) => {
    return state.customer.updateKycErrorMessage;
  });

  useEffect(() => {
    if (updateKycErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerUpdateKycDoc());
      }, 60000);
    }
  }, [updateKycErrorMessage]);

  const deleteKycErrorMessage = useSelector((state) => {
    return state.customer.deleteKycErrorMessage;
  });

  useEffect(() => {
    if (deleteKycErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerDeleteKycDoc());
      }, 60000);
    }
  }, [deleteKycErrorMessage]);

  const shareKycErrorMessage = useSelector((state) => {
    return state.customer.shareKycErrorMessage;
  });

  useEffect(() => {
    if (shareKycErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerShareKycDoc());
      }, 60000);
    }
  }, [shareKycErrorMessage]);

  const nomineeUpdate = useSelector((state) => {
    return state.customer.nomineeprofileErrorMessage;
  });

  useEffect(() => {
    if (nomineeUpdate?.length > 0) {
      setTimeout(() => {
        dispatch(clearnomineeProfileUpdateError());
      }, 60000);
    }
  }, [nomineeUpdate]);

  const nomineeProfilePicUpdate = useSelector((state) => {
    return state.customer.setNomineeProfilePicErrorMessage;
  });

  useEffect(() => {
    if (nomineeProfilePicUpdate?.length > 0) {
      setTimeout(() => {
        dispatch(clearnomineeProfilepicError());
      }, 60000);
    }
  }, [nomineeProfilePicUpdate]);

  // property 429 error Handling

  const propertyUploadDocMessgae = useSelector((state) => {
    return state.property.setNomineeProfilePicErrorMessage;
  });

  useEffect(() => {
    if (propertyUploadDocMessgae?.length > 0) {
      setTimeout(() => {
        dispatch(clearUploadDocErrorMsg());
      }, 60000);
    }
  }, [propertyUploadDocMessgae]);

  const propertyShareMessgae = useSelector((state) => {
    return state.property.shareDocErrorMessage;
  });

  useEffect(() => {
    if (propertyShareMessgae?.length > 0) {
      setTimeout(() => {
        dispatch(clearshareDocErrorMsg());
      }, 60000);
    }
  }, [propertyShareMessgae]);

  //  clear Verify Document Error Message

  const verifyDocumentErrorMsg = useSelector((state) => {
    return state.property.verifyDocumentErrorMsg;
  });

  useEffect(() => {
    if (verifyDocumentErrorMsg?.length > 0) {
      setTimeout(() => {
        dispatch(clearVerifyDocErrorMsg());
      }, 60000);
    }
  }, [verifyDocumentErrorMsg]);

  const propertyDeleteDocMessgae = useSelector((state) => {
    return state.property.deleteDocErrorMessage;
  });

  useEffect(() => {
    if (propertyDeleteDocMessgae?.length > 0) {
      setTimeout(() => {
        dispatch(clearDeleteDocErrorMsg());
      }, 60000);
    }
  }, [propertyDeleteDocMessgae]);

  const propertyRiskErrorMessage = useSelector((state) => {
    return state.property.riskDocErrorMessage;
  });

  useEffect(() => {
    if (propertyRiskErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearRiskErrorMsg());
      }, 60000);
    }
  }, [propertyRiskErrorMessage]);

  // my Address Error handling

  const addAddressErrorMessage = useSelector((state) => {
    return state.property.addAddressErrorMessage;
  });

  useEffect(() => {
    if (addAddressErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomeraddAddressErrorMsg());
      }, 60000);
    }
  }, [addAddressErrorMessage]);

  const updateAddressErrorMessage = useSelector((state) => {
    return state.property.updateAddressErrorMessage;
  });

  useEffect(() => {
    if (updateAddressErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerupdateAddressErrorMsg());
      }, 60000);
    }
  }, [updateAddressErrorMessage]);

  const deleteAddressErrorMessage = useSelector((state) => {
    return state.property.deleteAddressErrorMessage;
  });

  useEffect(() => {
    if (deleteAddressErrorMessage?.length > 0) {
      setTimeout(() => {
        dispatch(clearCustomerdeleteAddressErrorMsg());
      }, 60000);
    }
  }, [deleteAddressErrorMessage]);

  // customer Error Message Clearness

  const [Info, setInfo] = useState({});
  const { success: customerSuccess, Info: customerInfo } = useSelector(
    (state) => state.customer,
  );
  useEffect(() => {
    if (userType === "customer") {
      setInfo(customerInfo);
    }
  }, [customerInfo]);

  useEffect(() => {
    if (customerInfo) {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        dispatch(getCredits({}));
      }
    }
  }, [customerInfo]);

  useEffect(() => {
    setOptions([
      { name: "Documents", path: "/states", navId: "property_docs", freeTag: NAV_FREE_TAG, Icon: FileText },
      { name: "Services", path: "/services", navId: "property_services", Icon: Briefcase },
      // Hidden for now: Intelligence
      // { name: "Intelligence", path: "/intelligence", navId: "intelligence", Icon: Sparkles },
      // Opens the survey tools directly; Upload & Earn is a tab on the same page.
      { name: "Survey Maps", id: "maps", path: "/maps?tab=survey", navId: "my_locker", Icon: MapIcon },
      // A dropdown (PropertiesNavMenu): My Properties, Buy, Rent, Sell / List,
      // Bank Auctions.
      { name: "Properties", path: "/properties/listings", navId: "listings", Icon: Building2, menu: true },
      // Hidden for now: Community
      // { name: "Community", path: "/properties/community", navId: "community", Icon: Users2 },
    ]);
  }, [userType, Info]);

  const dropdownRef = useRef(null);
  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedNav(null); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (pathname.startsWith("/servicepartner/dashboard")) {
  //     setSelectedNav("/servicepartner/dashboard");
  //   } else if (pathname.startsWith("/services")) {
  //     setSelectedNav("/services");
  //   } else {
  //     setSelectedNav(pathname);
  //   }
  // }, [pathname]);

  const isUser = localStorage.getItem("token");

  const [rightSideNav, setRightSideNav] = useState(false);

  const menuBarToggle = () => {
    setRightSideNav(!rightSideNav);
  };

  const logoutHandler = () => {
    const status = "offline";
    Promise.all([
      dispatch(updateUserStatus(status)),
      dispatch(logoutUser(userType)),
    ]).then((results) => {
      if (
        results[0]?.payload?.data?.success === false &&
        results[0]?.payload?.status === 404
      ) {
        toast.error("Logout Failed");
      }
      if (results[0]?.payload?.response?.status === 200) {
        // toast.success("sucesss Logout");
        dispatch(clearUniversalSearchSuggestion());
        const token = JSON.parse(localStorage.getItem("token"));

        // setLoading(true);

        const clientuserId = localStorage.getItem("clientUserId");

        if (!clientuserId) {
          const newClientUserId = Array.from({ length: 24 }, () =>
            Math.floor(Math.random() * 16).toString(16),
          ).join("");

          localStorage.setItem("clientUserId", newClientUserId);
        }
      }
    });

    logout();
    dispatch(clearCustomer());
    dispatch(clearLogin());
    dispatch(clearSignup());
    setRightSideNav(false);
    navigate("/");
    sessionStorage.clear();
    localStorage.setItem("isPublic", true);
    dispatch(setPropertiesMenu({ name: "AllProperties", isPublic: true }));
    localStorage.removeItem("userId", true);
  };

  const openAuthModal = (modalName) => {
    setAuthModals((prevAuthModals) => ({
      ...prevAuthModals,
      [modalName]: true,
    }));
  };

  const closeAuthModal = (modalName) => {
    dispatch(loginPopupHandler(false));
    setAuthModals((prevAuthModals) => ({
      ...prevAuthModals,
      [modalName]: false,
    }));
  };

  const sendToDashBoard = () => {
    navigate("/customer/dashboard");
    setAnchorEl(null);
  };
  const calculatedHeight = `calc(100vh - 93vh)`;

  const generateReferralCode = () => {
    const referralUrl = `${window.location.origin}?referral=${referralCode}`;

    dispatch(createReferral()).then((res) => {
      if (res?.payload?.response?.status == 200) {
        if (res?.payload?.response?.data?.data?.item?.code) {
          setOpenReferralModal(true);
          const referralUrl = `${window.location.origin}?referral=${res?.payload?.response?.data?.data?.item?.code}`;
          setReferralCodeUrl(referralUrl);
        }
      }
    });
  };

  const isScrolled = false;
  return (
    <>
      <style>{`
        @keyframes jh-nav-cs-zoom {
          0%, 100% { transform: scale(1);    box-shadow: 0 2px 6px rgba(28,75,147,0.45); }
          50%       { transform: scale(1.25); box-shadow: 0 4px 14px rgba(240,165,0,0.75); }
        }
        .jh-nav-cs-badge {
          animation: jh-nav-cs-zoom 1.8s ease-in-out infinite;
        }
        @keyframes jh-nav-free-zoom {
          0%   { transform: scale(1);    box-shadow: 0 2px 6px rgba(5,150,105,0.4); }
          40%  { transform: scale(1.35); box-shadow: 0 6px 18px rgba(5,150,105,0.7); }
          55%  { transform: scale(1.28); box-shadow: 0 5px 14px rgba(5,150,105,0.6); }
          70%  { transform: scale(1.35); box-shadow: 0 6px 18px rgba(5,150,105,0.7); }
          100% { transform: scale(1);    box-shadow: 0 2px 6px rgba(5,150,105,0.4); }
        }
        .jh-nav-free-badge {
          animation: jh-nav-free-zoom 2.2s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
        }
      `}</style>
      <nav className="navbar-wrapper w-full h-16 flex items-center justify-between max-[1020px]:hidden bg-[#153568] border-b border-[#0c2244] shadow-[0_6px_18px_-10px_rgba(12,34,68,0.6)]">
        <div className="w-full px-6 xl:px-8 flex h-full items-center gap-4">
          <Link
            to="/"
            onClick={() => scrollTo(0, 0)}
            className="flex shrink-0 items-center"
          >
            <span className="flex flex-col items-start leading-none">
              <img
                // src={LogoDark}
                src={
                  isScrolled
                    ? jaaga
                    : `${PUBLIC_IMAGES_BASE_URI}/jaaga.webp`
                }
                // src={`${PUBLIC_IMAGES_BASE_URI}/jaaga.webp`}
                alt="JaaGa, Everything Your Property Needs"
                className="h-11 w-auto brightness-0 invert"
                // The logo is the first thing in the viewport, so it must not be
                // lazy — lazy defers it behind the layout pass and it was the
                // last above-the-fold pixel to paint. Both sources (the local
                // Group.webp and the R2 jaaga.webp) share the same 3.23:1 ratio,
                // so one width/height pair reserves the right box across the
                // isScrolled swap and stops the nav reflowing on load. Height is
                // pinned by `h-11`; these attributes only supply the ratio.
                width={1205}
                height={373}
              />
              <span className="-mt-1 ml-[33px] block w-[109px] text-[9px] font-semibold text-white/75 [text-align-last:justify]">
                Everything For Property
              </span>
            </span>
          </Link>
          {/* {userType !== "servicePartner" && userType !== "admin" && (
            <div className="  w-[338px]">
              <SearchableDropdown
                sx={{ width: "full" }}
                list={[
                  { name: "Aaron" },
                  { name: "Samson" },
                  { name: "Peter" },
                ]}
              />
            </div>
          )} */}
          <div
            className="left-nav flex flex-1 items-center justify-center gap-x-1 heading font-normal whitespace-nowrap"
            id="center"
          >
            {options &&
              options.map((item, index) => {
                if (item.menu) {
                  return (
                    <PropertiesNavMenu
                      key={index}
                      active={activeNavId === item.navId}
                      onPick={(it) => {
                        setActiveNavId(item.navId);
                        sessionStorage.setItem("activeNav", item.navId);
                        trackNavClick(item.navId, { label: `${item.name} / ${it.title}`, path: it.path });
                      }}
                    />
                  );
                }
                return (
                  <div key={index} className="relative">
                    <NavLink
                      to={item.path}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        // Light up immediately on click so the section is
                        // active even before the route resolves to a slug.
                        if (item.navId) {
                          setActiveNavId(item.navId);
                          sessionStorage.setItem("activeNav", item.navId);
                        }
                        // Funnel step 2, top-nav click. `navId` is the
                        // canonical id (property_docs / my_locker / etc.)
                        // so Mixpanel can group across languages even if
                        // the visible label gets translated.
                        if (item.navId) {
                          trackNavClick(item.navId, {
                            label: item.name,
                            path: item.path,
                          });
                        }
                      }}
                      className={({ isActive }) => {
                        const active = item.navId
                          ? activeNavId === item.navId
                          : isActive;
                        return [
                          "h-9 px-3.5 text-[15px] xl:h-10 xl:px-5 xl:text-[17px] whitespace-nowrap rounded-full transition-all duration-200 inline-flex items-center justify-center gap-1.5 align-middle",
                          active
                            ? "font-semibold bg-white text-[#153568] shadow-[0_6px_16px_-6px_rgba(0,0,0,0.35)]"
                            : "font-medium text-white/90 hover:bg-white/[0.12] hover:text-white",
                        ].join(" ");
                      }}
                    >
                      {({ isActive }) => {
                        const active = item.navId
                          ? activeNavId === item.navId
                          : isActive;
                        const ItemIcon = item.Icon;
                        return (
                          <span className="inline-flex items-center justify-center gap-1.5">
                            {ItemIcon && (
                              <ItemIcon
                                size={17}
                                strokeWidth={active ? 2.4 : 2}
                                className="shrink-0"
                                aria-hidden="true"
                              />
                            )}
                            <span className="leading-none">{item.name}</span>
                          </span>
                        );
                      }}
                    </NavLink>
                    {item.isNew && (
                      <span className="jh-nav-cs-badge pointer-events-none absolute -right-2 -top-2 z-10 whitespace-nowrap rounded-full bg-gradient-to-r from-[#f0a500] to-[#ffb300] px-1.5 py-0.5 text-[8.5px] font-bold uppercase leading-none tracking-wide text-white">
                        Coming Soon
                      </span>
                    )}
                    {item.freeTag && (
                      <span className="jh-nav-free-badge pointer-events-none absolute -right-2 -top-2 z-10 whitespace-nowrap rounded-full bg-gradient-to-r from-emerald-500 to-emerald-600 px-1.5 py-0.5 text-[8.5px] font-bold uppercase leading-none tracking-wide text-white">
                        Free
                      </span>
                    )}
                  </div>
                );
              })}
          </div>

          <div
            className="right-nav flex shrink-0 items-center justify-end gap-2.5 xl:gap-3.5"
            id="right"
          >
            {isUser ? (
              <>
                {/* 1, Contact / support */}
                <div className="group relative shrink-0">
                  <button
                    aria-label="Contact us"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate("/contactus");
                    }}
                    className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-colors bg-transparent text-white hover:bg-white/[0.12]"
                  >
                    <Headset size={18} strokeWidth={2} />
                  </button>
                  {/* Hover popup — slides in under the support button */}
                  <span className="pointer-events-none absolute right-0 top-full z-20 mt-2 origin-top translate-y-1 whitespace-nowrap rounded-lg bg-[#153568] px-3 py-1.5 text-xs font-semibold text-white opacity-0 shadow-lg transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100">
                    Contact us
                  </span>
                </div>

                {userType === "customer" && (
                  <>
                    {/* 2, My Orders */}
                    <a
                      href="/customer/dashboard/overview"
                      className={`inline-flex h-9 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-xl border-[1.5px] border-white/55 px-3 text-sm font-bold transition-colors ${
                        activeNavId === "orders"
                          ? "bg-white text-[#153568]"
                          : "text-white hover:bg-white/[0.12]"
                      }`}
                    >
                      My Orders
                    </a>

                    {/* 3, Credits */}
                    <div className="inline-flex h-9 shrink-0 justify-center items-center gap-1.5 pl-[0.3125rem] pr-2.5 rounded-xl bg-[#f0a500] text-[#0c2244] shadow-[0_6px_16px_-8px_rgba(240,165,0,0.8)] hover:bg-[#ffc53d]">
                      <div
                        className="flex items-center cursor-pointer"
                        aria-describedby={walletId}
                        onClick={(e) => {
                          toggleWallet(e);
                        }}
                      >
                        <img src={Coin} alt="Coin" style={{ height: "24px" }} />

                        <div
                          className={
                            "font-extrabold py-[1px] text-[#0c2244]"
                          }
                        >
                          {credits}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Notification alert (customer only, when present) */}
                {userType === "customer" &&
                  (unreadMsgs?.length > 0 ||
                    unPaidtransactions?.length > 0) && (
                    <div className="flex shrink-0 items-center">
                      <a
                        className=" flex  gap-2 relative cursor-pointer"
                        href="/customer/dashboard"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleNotification();
                        }}
                      >
                        <NotificationsActiveIcon
                          sx={{ color: "#ffffff" }}
                        />

                        <div className=" bg-red-500 rounded-full top-[-55%] right-[-50%] absolute px-1.5 ">
                          <p className=" font-normal  text-sm  text-white">
                            {unreadMsgs?.length + unPaidtransactions?.length}
                          </p>
                        </div>
                      </a>
                    </div>
                  )}

                {/* 4, Profile */}
                <div onClick={menuBarToggle} className="shrink-0 cursor-pointer">
                  {Info?.profilePic ? (
                    <div className="w-[30px] h-[30px] rounded-full border-[1.5px] border-white/70 overflow-hidden">
                      <img
                        src={Info.profilePic}
                        alt="profilepic"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <p
                      className={`${
                        isScrolled && "bg-white "
                      } w-[30px] h-[30px] flex items-center justify-center rounded-full border-[1.5px] border-white/55 bg-white/[0.14] text-white hover:bg-white hover:text-[#153568] text-lg font-bold`}
                    >
                      {Info?.name?.[0] || "A"}
                    </p>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="group relative shrink-0">
                  <button
                    aria-label="Contact us"
                    onClick={() => {
                      navigate("/contactus");
                    }}
                    className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-colors bg-transparent text-white hover:bg-white/[0.12]"
                  >
                    <Headset size={18} strokeWidth={2} />
                  </button>
                  {/* Hover popup — slides in under the support button */}
                  <span className="pointer-events-none absolute right-0 top-full z-20 mt-2 origin-top translate-y-1 whitespace-nowrap rounded-lg bg-[#153568] px-3 py-1.5 text-xs font-semibold text-white opacity-0 shadow-lg transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100">
                    Contact us
                  </span>
                </div>
                <Button
                  variant="outline"
                  className="h-9 px-4 border-white bg-white font-bold text-[#153568] hover:bg-white/90 hover:text-[#153568]"
                  onClick={() => {
                    navigate("/app#");
                  }}
                >
                  Download App
                </Button>
                <Button
                  onClick={() => openAuthModal("Login")}
                  className="h-9 px-5 bg-[#f0a500] font-bold text-[#0c2244] hover:bg-[#ffc53d] cursor-pointer"
                >
                  Login
                </Button>
              </>
            )}
          </div>
        </div>
      </nav>
      <nav className="navbar-wrapper2 bg-[#153568] border-b border-[#0c2244] hidden max-[1020px]:block">
        <div className="nav2-top flex items-center justify-between gap-2 px-4 py-2.5">
          {/* Logo (left-aligned), with the tagline back under the wordmark.
              Kept to a single line with whitespace-nowrap at a smaller size
              than the desktop version so it doesn't wrap and look cramped. */}
          <Link to="/" id="center-nav" className="shrink-0">
            <span className="flex flex-col items-start leading-none">
              <img
                src={`${PUBLIC_IMAGES_BASE_URI}/jaaga.webp`}
                alt="JaaGa, Everything Your Property Needs"
                className="h-8 w-auto brightness-0 invert"
                // Intrinsic size of the R2 asset, so the mobile bar reserves the
                // logo's box before it arrives. `h-8` still drives the height.
                width={1205}
                height={373}
              />
              <span className="-mt-0.5 ml-6 block whitespace-nowrap text-[7px] font-semibold text-white/75">
                Everything For Property
              </span>
            </span>
          </Link>

          {/* Right-side actions */}
          {isUser ? (
            <div className="flex items-center gap-2">
              {/* Credits chip */}
              <button
                type="button"
                aria-describedby={walletId}
                onClick={(e) => toggleWallet(e)}
                className="inline-flex items-center gap-1 rounded-full bg-[#f0a500] px-2.5 py-1.5 transition active:scale-95"
              >
                <img
                  src={Coin}
                  alt=""
                  className="h-[18px] w-[18px] object-contain"
                />
                <span
                  className={
                    "text-sm font-extrabold leading-none tabular-nums text-[#0c2244]"
                  }
                >
                  {credits}
                </span>
              </button>

              {/* Profile (opens profile drawer) */}
              <button
                type="button"
                onClick={menuBarToggle}
                aria-label="Open profile"
                className="flex h-9 w-9 items-center justify-center rounded-full transition active:scale-95"
              >
                {Info?.profilePic ? (
                  <span className="block h-8 w-8 overflow-hidden rounded-full border-[1.5px] border-white/70">
                    <img
                      src={Info.profilePic}
                      alt="profilepic"
                      className="h-full w-full object-cover"
                    />
                  </span>
                ) : (
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-white/55 bg-white/[0.14] text-base font-bold text-white">
                    {Info?.name?.[0]?.toUpperCase() || "A"}
                  </span>
                )}
              </button>
            </div>
          ) : (
            <div className="flex shrink-0 items-center gap-1.5">
              <Button
                variant="outline"
                className="h-8 rounded-full border-white bg-white px-3 text-xs font-bold text-[#153568] hover:bg-white/90 hover:text-[#153568]"
                onClick={() => navigate("/app#")}
              >
                Download App
              </Button>
              <Button
                onClick={() => openAuthModal("Login")}
                className="h-8 rounded-full bg-[#f0a500] px-4 text-xs font-bold text-[#0c2244] hover:bg-[#ffc53d]"
              >
                {CD.Login}
              </Button>
            </div>
          )}
        </div>
      </nav>
      <Drawer open={rightSideNav} onClose={menuBarToggle} anchor="right" sx={{ zIndex: 1450 }}>
        <div className="profile-drawer flex w-[400px] max-w-[92vw] flex-col bg-[#f2f6fb]">
          {Info && Object.keys(Info)?.length !== 0 ? (
            <>
              {/* Navy header — shared shell with the wallet + notification drawers */}
              <div className="relative overflow-hidden bg-gradient-to-b from-[#1a417e] to-[#0c2244] px-5 pb-5 pt-3">
                {/* soft ambient glows for depth */}
                <div className="pointer-events-none absolute -right-10 -top-12 h-40 w-40 rounded-full bg-[#1c4b93]/20 blur-3xl" />
                <div className="pointer-events-none absolute -bottom-16 -left-10 h-40 w-40 rounded-full bg-white/10 blur-3xl" />

                <div className="relative flex items-center justify-between">
                  <a
                    href={
                      userType === "customer"
                        ? "/customer/personalinfo/aboutme"
                        : "/servicepartner/personalinfo"
                    }
                    onClick={menuBarToggle}
                    className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-4 py-1.5 text-sm font-semibold text-white no-underline transition hover:bg-white/25"
                  >
                    <Pencil size={14} />
                    {CD.Edit}
                  </a>
                  <button
                    type="button"
                    onClick={menuBarToggle}
                    aria-label="Close"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25"
                  >
                    <CloseX size={18} />
                  </button>
                </div>

                <div className="relative mt-2 flex flex-col items-center text-center">
                  {Info?.profilePic ? (
                    <div className="h-[84px] w-[84px] overflow-hidden rounded-full border-2 border-white/60">
                      <img
                        src={Info.profilePic}
                        alt="profilepic"
                        className="h-full w-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="flex h-[84px] w-[84px] items-center justify-center rounded-full border-2 border-white/60 bg-white/10 text-3xl font-bold text-white">
                      {Info?.name?.[0]?.toUpperCase() || "A"}
                    </div>
                  )}
                  <p className="mt-2 text-lg font-bold text-white">
                    {Info?.name}
                  </p>
                  <p className="text-sm text-white/60">
                    {Info?.phone?.number &&
                      `${Info?.phone?.countryCode || ""}${Info?.phone?.number}`}
                  </p>
                </div>
              </div>

              {/* Body */}
              <div className="flex flex-col gap-2.5 px-4 py-3">
                {/* Credits */}
                <div className="rounded-xl border border-slate-200 bg-white p-3.5 shadow-sm">
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#eef2f9] text-[#153568]">
                      <CreditCard size={20} />
                    </span>
                    <div>
                      <p className="text-2xl font-extrabold leading-none text-[#153568]">
                        {credits}
                      </p>
                      <p className="text-xs text-slate-500">Credits available</p>
                    </div>
                  </div>
                  <div className="mt-3">
                    <button
                      type="button"
                      onClick={() => {
                        // Open the add-credits popup in place instead of
                        // navigating away to the credits page.
                        menuBarToggle();
                        setOpenCreditsPopUp(true);
                      }}
                      className="inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-[#153568] py-2.5 text-sm font-semibold text-white transition hover:bg-[#0f2a52]"
                    >
                      <Plus size={15} /> Add Credits
                    </button>
                  </div>
                </div>

                {/* Refer & earn */}
                <div className="rounded-xl border border-slate-200 bg-white p-3.5 shadow-sm">
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#e4edf8] text-[#b8922a]">
                      <Gift size={20} />
                    </span>
                    <div>
                      <p className="text-sm font-bold text-[#153568]">
                        Refer &amp; earn {referralCredits} credits
                      </p>
                      <p className="text-xs text-slate-500">
                        Invite a friend, you both get free credits
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => generateReferralCode()}
                    className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#153568] py-2.5 text-sm font-semibold text-white transition hover:bg-[#0f2a52]"
                  >
                    <Share2 size={15} /> Refer now
                  </button>
                </div>

                {/* Action list */}
                <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
                  <button
                    type="button"
                    onClick={() => {
                      navigate("/contactus");
                      menuBarToggle();
                    }}
                    className="flex w-full items-center gap-3 border-b border-slate-100 px-4 py-3 text-left transition hover:bg-slate-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#eef2f9] text-[#153568]">
                      <MessageSquare size={17} />
                    </span>
                    <span className="flex-1 text-sm font-medium text-[#153568]">
                      Contact us
                    </span>
                    <ChevronRight size={16} className="text-slate-400" />
                  </button>

                  <a
                    href="https://wa.me/918885166002"
                    target="_blank"
                    rel="noreferrer"
                    onClick={menuBarToggle}
                    className="flex w-full items-center gap-3 border-b border-slate-100 px-4 py-3 text-left no-underline transition hover:bg-slate-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#e8f9ee] text-[#16a34a]">
                      <MessageCircle size={17} />
                    </span>
                    <span className="flex-1 text-sm font-medium text-[#153568]">
                      Chat with us
                    </span>
                    <ChevronRight size={16} className="text-slate-400" />
                  </a>

                  <button
                    type="button"
                    onClick={() => {
                      navigate("/contactus");
                      menuBarToggle();
                    }}
                    className="flex w-full items-center gap-3 px-4 py-3 text-left transition hover:bg-rose-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-rose-50 text-rose-600">
                      <UserX size={17} />
                    </span>
                    <span className="flex-1 text-sm font-medium text-rose-600">
                      Account deletion request
                    </span>
                    <ChevronRight size={16} className="text-rose-300" />
                  </button>
                </div>

                {/* Log out */}
                <button
                  type="button"
                  onClick={logoutHandler}
                  className="mt-1 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-rose-200 bg-white py-3 text-sm font-bold text-rose-600 shadow-sm transition hover:bg-rose-50"
                >
                  <LogOut size={16} /> Log out
                </button>
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center gap-4 p-8">
              <Button
                variant="outlined"
                style={{ textTransform: "capitalize" }}
                startIcon={<DriveFileRenameOutlineIcon />}
                onClick={() => openAuthModal("Login")}
              >
                {CD.Login}
              </Button>
            </div>
          )}

          {openreferralModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <RefferModal
                setShareWindow={() => {
                  setOpenReferralModal(false);
                }}
                encodedShareUrl={referralCodeUrl}
                encodedShareText={`Hey! I've been using JaaGa for property documentation. Super easy and professional! You should try it too! Use my referral link to get ${joiningCredits} JaaGa Credits.`}
              />
            </div>
          )}
        </div>
      </Drawer>

      {/* <div className='Auth-Modals'>
				<Modal
					open={AuthModals.Login || loginPopUp}
					onClose={() => openAuthModal("Login")}
					aria-labelledby='modal-modal-title'
					aria-describedby='modal-modal-description'
				>
					<Box className='h-screen flex items-center justify-center'>
						<Login
							openAuthModal={openAuthModal}
							closeAuthModal={closeAuthModal}
						/>
					</Box>
				</Modal>
			</div> */}
      <div className="Auth-Modals">
        <Modal
          open={AuthModals.Login || loginPopUp}
          onClose={() => openAuthModal("Login")}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="h-screen flex items-center justify-center">
            {/* <Authentication openAuthModal={openAuthModal} closeAuthModal={closeAuthModal} /> */}
            <Suspense fallback={null}>
              <Login
                openAuthModal={openAuthModal}
                closeAuthModal={closeAuthModal}
              />
            </Suspense>
          </Box>
        </Modal>
      </div>

      <div className="credits-Modals relative">
        <Modal
          open={openCreditsPopUp || OutOFCreditsPopUp}
          onClose={() => {
            setOpenCreditsPopUp(false);
            localStorage.removeItem("sendingCredits");
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="h-screen flex items-center justify-center">
            <Suspense fallback={null}>
              <OutOfCredits
                closeCreditsPopUp={() => {
                  localStorage.removeItem("sendingCredits");

                  (setOpenCreditsPopUp(false),
                    dispatch(OutOFCreditsPopUpHandler(false)));
                }}
                outOfCredits={OutOFCreditsPopUp}
              />
            </Suspense>
          </Box>
        </Modal>
      </div>

      <Drawer open={openWallet} onClose={handleWalletClose} anchor="right" sx={{ zIndex: 1450 }}>
        <div className="h-full w-[400px] max-w-[92vw] overflow-y-auto bg-[#f2f6fb]">
          <Suspense fallback={null}>
            <Wallet
              sendToDashBoard={sendToDashBoard}
              handleWalletClose={handleWalletClose}
            />
          </Suspense>
        </div>
      </Drawer>
      <Drawer
        open={openNotification}
        onClose={handleNotificationClose}
        anchor="right"
        sx={{ zIndex: 1450 }}
      >
        <div className="h-full w-[400px] max-w-[92vw] overflow-y-auto bg-[#f2f6fb]">
          <Suspense
            fallback={
              <div className="h-full w-full animate-pulse bg-slate-100" />
            }
          >
            <Notification
              sendToDashBoard={sendToDashBoard}
              notificationsData={unreadMsgs}
              unPaidtransactions={unPaidtransactions}
              handleNotificationClose={handleNotificationClose}
            />
          </Suspense>
        </div>
      </Drawer>

      {/* Mobile bottom tab bar, primary section switcher on < 1020px. */}
      <BottomNav />
      {/* Phones: keep the focused field above the keyboard, hide bottom bars. */}
      <MobileKeyboardManager />
    </>
  );
};

export default Navbar;
